import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopanchganicab() {



    const cardData = {

keyword: "Mumbai to Panchgani Cab",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and reliable Mumbai to Panchgani Cab services for families, couples, corporate travelers, weekend tourists, and hill station lovers. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with experienced chauffeurs for a smooth and scenic journey through the Western Ghats. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip cab bookings, customized sightseeing plans, 24/7 customer support, and transparent pricing, we ensure a hassle-free and enjoyable trip to Panchgani, a beautiful hill station known for its table land, strawberry farms, colonial charm, viewpoints, and pleasant climate.",

topPlaces: [
    {
        title: "Table Land",
        description:
            "Table Land is the most famous attraction in Panchgani and one of the largest volcanic plateaus in Asia. It offers vast open space, horse riding, paragliding, local food stalls, and breathtaking panoramic views of the surrounding hills and valleys. The cool breeze and scenic landscapes make it a perfect spot for families, couples, and photographers visiting from Mumbai."
    },
    {
        title: "Sydney Point",
        description:
            "Sydney Point provides stunning views of the Krishna Valley, Dhom Dam, and surrounding green hills. It is especially popular during sunrise and sunset when the sky creates a beautiful backdrop over the valley. Visitors enjoy peaceful moments, photography, and natural beauty at this iconic Panchgani viewpoint."
    },
    {
        title: "Parsi Point",
        description:
            "Parsi Point is a scenic viewpoint overlooking the Krishna Valley and lush green landscapes. It is known for its cool climate, refreshing atmosphere, and spectacular views of the hills. Families and tourists often stop here to enjoy snacks, photography, and relaxing breaks during their Panchgani sightseeing trip."
    },
    {
        title: "Mapro Garden",
        description:
            "Mapro Garden is one of the most popular tourist attractions near Panchgani, famous for its strawberry products, chocolates, ice creams, and fresh fruit-based beverages. Visitors can explore beautiful gardens, enjoy delicious food, and shop for locally made products. It is a must-visit stop on the Mumbai to Panchgani cab route."
    },
    {
        title: "Dhom Dam",
        description:
            "Dhom Dam is a large reservoir near Panchgani offering serene water views, boating opportunities, and scenic surroundings. The calm atmosphere and green hills around the dam make it an ideal destination for relaxation, photography, and nature appreciation."
    },
    {
        title: "Devil’s Kitchen",
        description:
            "Devil’s Kitchen is a historic cave site linked to the Pandavas from the Mahabharata. It is located near Table Land and offers a mix of mythology, history, and adventure. The surrounding views and rocky terrain make it a fascinating attraction for explorers and history enthusiasts."
    },
    {
        title: "Panchgani Strawberry Farms",
        description:
            "Panchgani is famous for its strawberry farms where visitors can experience fresh strawberry picking during the season. Tourists enjoy farm visits, tasting fresh produce, and learning about local agriculture. The farms add a unique and refreshing experience to the hill station tour."
    },
    {
        title: "Panchgani Heritage Walk",
        description:
            "The heritage walk in Panchgani showcases colonial-era architecture, old boarding schools, churches, and traditional British-style buildings. Visitors enjoy exploring the town’s history while walking through its peaceful streets surrounded by scenic hills and greenery."
    },
    {
        title: "Bhilar Waterfall",
        description:
            "Bhilar Waterfall is a seasonal waterfall located near Panchgani, becoming especially beautiful during the monsoon season. Surrounded by lush greenery and misty hills, it offers a refreshing natural escape for tourists and nature lovers traveling from Mumbai."
    },
    {
        title: "Lingmala Waterfall View Point",
        description:
            "Lingmala Waterfall viewpoint offers stunning views of cascading water surrounded by dense forests and valleys. It is a popular stop for travelers heading toward Mahabaleshwar and Panchgani, providing a perfect blend of adventure and natural beauty during the journey."
    }
],



services: [
{
name: "Mumbai to Panchgani Cab",
description: "Mumbai Airport Cab offers Mumbai to Panchgani Cab service for safe, comfortable, and affordable travel to the beautiful hill station of Panchgani in Maharashtra. Whether you are planning a family vacation, weekend getaway, romantic trip, corporate outing, school tour, or sightseeing holiday, we provide well-maintained AC Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, Tempo Traveller, and luxury vehicles. Our professional chauffeurs ensure a smooth and scenic journey via the Mumbai–Pune Expressway and Wai route with doorstep pickup, flexible schedules, one way and round trip options, transparent pricing, and 24x7 booking support. Enjoy a relaxing hill station drive with misty valleys, strawberry farms, viewpoints, and premium travel comfort from Mumbai Airport Cab."
},
{
name: "Mumbai to Panchgani Taxi",
description: "Book Mumbai to Panchgani Taxi with Mumbai Airport Cab for convenient, safe, and hassle-free travel. Our clean AC vehicles, experienced drivers, affordable fares, and flexible pickup options ensure a comfortable journey for families, couples, and groups visiting Panchgani."
},
{
name: "Mumbai to Panchgani Taxi Fare",
description: "Get affordable Mumbai to Panchgani Taxi Fare with Mumbai Airport Cab. We offer transparent pricing, multiple vehicle options, and economical travel packages with no hidden charges for one way and round trip journeys."
},
{
name: "Mumbai to Panchgani Cab Fare",
description: "Mumbai Airport Cab provides competitive Mumbai to Panchgani Cab Fare with professional chauffeurs, well-maintained vehicles, and reliable service for smooth hill station travel at the best value."
},
{
name: "Cab from Mumbai to Panchgani",
description: "Choose a Cab from Mumbai to Panchgani with Mumbai Airport Cab and enjoy a safe, scenic, and comfortable journey with experienced drivers and premium AC vehicles."
},
{
name: "Mumbai to Panchgani Car Rental",
description: "Book Mumbai to Panchgani Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles for flexible and comfortable travel tailored to your needs."
},
{
name: "Mumbai to Panchgani Cab Booking",
description: "Mumbai Airport Cab offers Mumbai to Panchgani Cab Booking with instant confirmation, 24x7 support, professional chauffeurs, and multiple vehicle options for all travel requirements."
},
{
name: "Mumbai to Panchgani One Way Cab",
description: "Travel conveniently with Mumbai to Panchgani One Way Cab service featuring fixed pricing, AC comfort, experienced drivers, and hassle-free pickup and drop services."
},
{
name: "Mumbai to Panchgani Round Trip Cab",
description: "Mumbai Airport Cab offers Mumbai to Panchgani Round Trip Cab packages for same-day returns, weekend trips, sightseeing tours, and family holidays with flexible travel schedules."
},
{
name: "Mumbai to Panchgani Outstation Cab",
description: "Book Mumbai to Panchgani Outstation Cab for reliable long-distance travel with premium vehicles, affordable fares, and customized travel plans for leisure and business trips."
},
{
name: "Mumbai to Panchgani Taxi Service",
description: "Mumbai Airport Cab provides Mumbai to Panchgani Taxi Service with safe transportation, clean AC vehicles, professional chauffeurs, and easy booking options."
},
{
name: "Mumbai to Panchgani Car Hire",
description: "Choose Mumbai to Panchgani Car Hire with Mumbai Airport Cab for chauffeur-driven travel with flexible timing, comfortable seating, and personalized service."
},
{
name: "Mumbai to Panchgani Innova Cab",
description: "Book Mumbai to Panchgani Innova Cab for spacious and comfortable family travel with ample luggage space, AC comfort, and premium seating for long hill journeys."
},
{
name: "Mumbai to Panchgani Ertiga Cab",
description: "Mumbai Airport Cab provides Mumbai to Panchgani Ertiga Cab service for economical family travel with comfortable seating, AC vehicles, and affordable pricing."
},
{
name: "Mumbai to Panchgani SUV Cab",
description: "Choose Mumbai to Panchgani SUV Cab for larger families and groups seeking spacious interiors, premium comfort, and smooth long-distance hill travel."
},
{
name: "Mumbai Airport to Panchgani Cab",
description: "Book Mumbai Airport to Panchgani Cab with direct pickup from domestic and international terminals. We provide flight tracking, luggage assistance, and comfortable AC vehicles for a smooth transfer to Panchgani."
},
{
name: "Navi Mumbai to Panchgani Cab",
description: "Mumbai Airport Cab offers Navi Mumbai to Panchgani Cab service with doorstep pickup, affordable fares, and comfortable travel options for families and groups."
},
{
name: "Thane to Panchgani Cab",
description: "Choose Thane to Panchgani Cab with Mumbai Airport Cab for reliable transportation, experienced chauffeurs, premium vehicles, and flexible travel schedules."
},
{
name: "Mumbai to Panchgani Weekend Cab",
description: "Book Mumbai to Panchgani Weekend Cab for relaxing short trips with flexible pickup timings, scenic hill views, and comfortable chauffeur-driven travel."
},
{
name: "Mumbai to Panchgani Family Trip Cab",
description: "Mumbai Airport Cab provides Mumbai to Panchgani Family Trip Cab service with spacious vehicles, safe drivers, and customized travel plans designed for enjoyable family vacations in Panchgani."
}
],

tableData: [
["Mumbai to Panchgani Cab","Mumbai to Panchgani Taxi"],
["Mumbai to Panchgani Taxi Fare","Mumbai to Panchgani Cab Fare"],
["Cab from Mumbai to Panchgani","Mumbai to Panchgani Car Rental"],
["Mumbai to Panchgani Cab Booking","Mumbai to Panchgani One Way Cab"],
["Mumbai to Panchgani Round Trip Cab","Mumbai to Panchgani Outstation Cab"],
["Mumbai to Panchgani Taxi Service","Mumbai to Panchgani Car Hire"],
["Mumbai to Panchgani Innova Cab","Mumbai to Panchgani Ertiga Cab"],
["Mumbai to Panchgani SUV Cab","Mumbai Airport to Panchgani Cab"],
["Navi Mumbai to Panchgani Cab","Thane to Panchgani Cab"],
["Mumbai to Panchgani Weekend Cab","Mumbai to Panchgani Family Trip Cab"]
],




whychoose: [
    {
        WhyChooseheading: "Trusted Mumbai to Panchgani Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides reliable Mumbai to Panchgani Cab transportation for families, tourists, couples, corporate travelers, and holidaymakers looking for a comfortable travel experience."
    },
    {
        WhyChooseheading: "Popular Hill Station Travel Solution",
        WhyChoosedescription: "Panchgani attracts visitors throughout the year with its pleasant climate, breathtaking viewpoints, strawberry farms, and peaceful natural surroundings."
    },
    {
        WhyChooseheading: "Comfortable Outstation Journey",
        WhyChoosedescription: "Travel through scenic mountain roads and lush green valleys in well-maintained vehicles driven by experienced and professional chauffeurs."
    },
    {
        WhyChooseheading: "Wide Selection of Vehicles",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles based on your group size and travel requirements."
    },
    {
        WhyChooseheading: "Flexible Travel Plans Available",
        WhyChoosedescription: "We offer one-way transfers, round trips, family vacations, weekend getaways, and customized Panchgani sightseeing packages."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Mumbai",
        WhyChoosedescription: "Pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
    },
    {
        WhyChooseheading: "Professional Drivers and Safe Travel",
        WhyChoosedescription: "Our trained drivers focus on passenger safety, punctuality, and delivering a stress-free travel experience throughout the journey."
    },
    {
        WhyChooseheading: "Ideal for Couples, Families, and Groups",
        WhyChoosedescription: "Whether it is a honeymoon trip, family vacation, weekend retreat, or corporate outing, we provide suitable travel options for every traveler."
    }
]
};

const faqData = [
    {
        question: "Why is Panchgani a popular destination from Mumbai?",
        answer: "Panchgani is famous for its beautiful landscapes, cool climate, Table Land, Sydney Point, strawberry farms, and relaxing hill station atmosphere."
    },
    {
        question: "Can I book a one-way cab from Mumbai to Panchgani?",
        answer: "Yes, Mumbai Airport Cabs offers one-way, round-trip, and customized travel packages for Panchgani."
    },
    {
        question: "Which vehicle is best for Mumbai to Panchgani travel?",
        answer: "Sedan cars, Ertiga, Innova Crysta, and SUVs are among the most preferred options for comfortable hill station travel."
    },
    {
        question: "Do you provide same-day return trips?",
        answer: "Yes, same-day return packages are available depending on your travel schedule and sightseeing requirements."
    },
    {
        question: "Can families use this service for vacations?",
        answer: "Yes, many families choose Mumbai Airport Cabs for holidays, summer vacations, and weekend trips to Panchgani."
    },
    {
        question: "Are Tempo Travellers available for groups?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for group tours, family outings, and corporate travel."
    },
    {
        question: "Can I get pickup from Mumbai Airport?",
        answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
    },
    {
        question: "Can sightseeing locations be included during the trip?",
        answer: "Yes, customers can visit Table Land, Sydney Point, Parsi Point, Mapro Garden, Devil's Kitchen, and nearby attractions."
    },
    {
        question: "Is advance booking recommended?",
        answer: "Yes, advance booking helps secure your preferred vehicle and ensures a smooth travel experience."
    },
    {
        question: "How can I book a Mumbai to Panchgani Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rahul Chavan",
        feedback:
            "The entire travel arrangement was handled professionally. The vehicle arrived on time, the ride was comfortable, and the driver was courteous throughout the journey.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Snehal Patwardhan",
        feedback:
            "Mumbai Airport Cabs delivered an excellent travel experience for our Panchgani holiday. The cab was spotless, the service was punctual, and the trip was enjoyable from start to finish.",
        rating: 5
    }
];


































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Panchgani Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-panchgani-cab.jpg",
"description": "Book Mumbai to Panchgani cab service for a comfortable hill station journey. Mumbai Airport Cabs offers reliable taxi service with professional drivers, clean vehicles, transparent pricing, and flexible one-way and round-trip options for Panchgani travel.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-panchgani-cab"
}
};







    return (
        <div>



<Helmet>
  <title>Mumbai to Panchgani Cab | Hill Station Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Panchgani cab service at affordable fares. Safe and comfortable taxi service with professional drivers, one-way and round-trip options, and reliable hill station travel from Mumbai to Panchgani."
/>

<meta
 name="keywords"
 content="mumbai to panchgani cab, mumbai to panchgani taxi, mumbai to panchgani taxi fare, mumbai to panchgani cab fare, cab from mumbai to panchgani, mumbai to panchgani car rental, mumbai to panchgani cab booking, mumbai to panchgani one way cab, mumbai to panchgani round trip cab, mumbai to panchgani outstation cab, mumbai to panchgani taxi service, panchgani hill station cab mumbai, mumbai panchgani car hire, best cab mumbai to panchgani"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/96.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitopanchganicab;